<template>
    <div class="quill-editor" ref="editor"></div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import Quill from "quill";

export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  // watch: {
  //   value(nu, old) {
  //     console.log(this.value);
  //   }
  // },
  data() {
    return {
      editor: null
    };
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "italic", "underline"],
          ["link"],
          ["video", "code-block"]
        ]
      },
      placeholder: "Текст..."
    });

    this.editor.root.innerHTML = this.value;

    this.editor.on("text-change", () => this.update());
  },

  methods: {
    update() {
      this.$emit(
        "input",
        this.editor.getText() ? this.editor.root.innerHTML : ""
      );
    }
  }
};
</script>

<style>
/* .quill-editor {
  width: 100%;
  height: 100%;
} */
.ql-toolbar {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.ql-container {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ql-editor {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Editor.vue